import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CountryFlagProps as Props } from './types';

export const CountryFlag = memo(({ className, iso2, country, size }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('CountryFlag', className)}
      sx={SX.root}
      src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/1x1/${iso2.toLowerCase()}.svg`}
      alt={country}
      width={size}
      height={size}
    />
  );
});

CountryFlag.displayName = 'CountryFlag';
